import { createAction, props } from '@ngrx/store';

import { ExportClickedEvent, ExportMetadata } from './export.models';

export const methodSelectionOpened = createAction('[Export] Method selection opened');

export const mailFormOpened = createAction('[Export] Mail form opened');

export const download = createAction('[Export] Download', props<ExportClickedEvent>());

export const downloadSucceeded = createAction(
  '[Export] Download succeeded',
  props<{
    action: ExportClickedEvent;
    result: Blob;
  }>()
);

export const forward = createAction(
  '[Export] Forward',
  props<{
    action: string;
    documentId?: string;
  }>()
);

export const downloadTrigger = createAction(
  '[Export] Download trigger',
  props<{
    action: ExportClickedEvent;
    result: Blob;
  }>()
);

export const trackDownloadSucceeded = createAction(
  '[Export] Track download succeeded',
  props<{
    action: ExportClickedEvent;
    result: Blob;
    file_name: string;
    file_extension: string;
  }>()
);

export const trackForwardSucceeded = createAction(
  '[Export] Track forward succeeded',
  props<{
    action: string;
    file_name: string | null | undefined;
    file_extension: string | null | undefined;
  }>()
);

export const downloadFailed = createAction('[Export] Download failed', props<ExportClickedEvent>());

export const identifyMeta = createAction('[Export] Identify metadata', props<{ documentId: string }>());

export const metaIdentificationSucceeded = createAction(
  '[Export] Metadata identification succeded',
  props<ExportMetadata>()
);

export const metaIdentificationFailed = createAction('[Export] Metadata identification failed');
